<div class="page-header ">
  <div class="flex xl:align-items-center flex-wrap xl:flex-nowrap gap-3">
    <div class="flex-grow-1">
      <!-- <app-primeng-breadcrumb></app-primeng-breadcrumb> -->
    </div>
    <div class="right-container flex flex-wrap xl:flex-nowrap gap-3 justify-end"></div>
  </div>

</div>

<div class="page-content mt-2">
  <p-stepper [(value)]="activeStep" [linear]="false">
    <p-step-list>

      <p-step [value]="0" class="flex-auto">
        <ng-template #content let-value="value" let-activateCallback="activateCallback">
          <p-button [text]="activeStep>=1"
            (onClick)=" onToggleTab('info', onEditClick);activateCallback('info',onEditClick)">
            <i-tabler name="building" class="ti-regular ti-lg"></i-tabler>
            Roles Info
          </p-button>
          <!-- <span [ngClass]="{
                          'bg-primary border-primary': value <= activeStep,
                          'surface-border': value > activeStep
                      }" (click)="value != activeStep ? onToggleTab('info', onEditClick) : null"
            (keydown)="activateCallback('info',onEditClick)">
            <i class="ti ti-building"></i> Organization Info
          </span> -->
        </ng-template>
      </p-step>

      <p-step [value]="1">
        <ng-template #content let-value="value" let-activateCallback="activateCallback">

          <p-button [text]="activeStep!=1" [disabled]="operation == 'new' && activeStep < 1"
            (onClick)=" onToggleTab('resources', onEditClick);activateCallback('resources',onEditClick)">
            <i-tabler name="user-plus" class="ti-regular ti-lg"></i-tabler>
            Assign Resources
          </p-button>
          <!-- <span [ngClass]="{
                      'bg-primary border-primary': value <= activeStep,
                      'surface-border': value > activeStep
                  }" (click)="activateCallback('admin',onEditClick); onToggleTab('admin', onEditClick)"
            (keydown)="activateCallback('admin',onEditClick); onToggleTab('admin', onEditClick)">
            <i class="ti ti-user-plus"></i> Add Admin
          </span> -->
        </ng-template>
      </p-step>

      <!-- <p-step [value]="2" >
        <ng-template #content let-value="value" let-activateCallback="activateCallback">
          <p-button [text]="activeStep!=2"
            (onClick)="onToggleTab('resources', onEditClick);activateCallback('resources',onEditClick)">
            <i-tabler name="layout-grid" class="ti-regular ti-lg"></i-tabler>
            Assign Scope
          </p-button>

           <span [ngClass]="{
                          'bg-primary border-primary': value <= activeStep,
                          'surface-border': value > activeStep
                      }" (click)="activateCallback('resources',onEditClick );  onToggleTab('resources', onEditClick)"
            (keydown)="activateCallback('resources', onEditClick ); onToggleTab('resources', onEditClick)">
            <i class="ti ti-apps"></i> Assign Resources
          </span> -->
      <!-- </ng-template>
      </p-step>  -->

    </p-step-list>

    <p-step-panels>

      <p-step-panel [value]="0" ngSkipHydration>
        <!-- Header -->
        <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
          <span (click)="onToggleTab('info', onClick)" (keydown)="onToggleTab('info', onClick)">
            <i class="ti ti-user"></i> Role Info
          </span>
        </ng-template>
        <!-- Content -->
        <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
          <form #f="ngForm" autocomplete="off">
            <div class="grid grid-cols-12 md:grid-cols-12 gap-4">

              <!-- Role Name -->
              <div class="md:col-span-6 flex flex-col gap-1">
                <ng-container *ngIf="operation !== 'view'; else viewRoleName">
                  <ng-container *ngIf="loading(); else roleNameTemplate">
                    <app-skeleton id="label-input-items"></app-skeleton>
                  </ng-container>
                  <ng-template #roleNameTemplate>
                    <label for="profile" class="label-text">Role Name<span class="text-red-500">*</span></label>
                    <input pInputText type="text" [(ngModel)]="profileData.firstName" class="form-control w-full"
                      name="name" id="name" placeholder="Role Name" required (input)="inputHasOnlyAlphabets($event)"
                      (blur)="inputHasOnlyAlphabets($event)" (keypress)="onlyAlphabet($event,25,true)"
                      (keydown)="space($event)" />
                    <div *ngIf="isNameTouched && isFormNotValid()">
                      <small class="text-red-500">* Role Name should not be empty</small>
                    </div>
                  </ng-template>
                </ng-container>

                <ng-template #viewRoleName>
                  <p-card class="card-border">
                    <ng-container *ngIf="loading(); else showRoleName">
                      <app-skeleton id="label-input-items"></app-skeleton>
                    </ng-container>
                    <ng-template #showRoleName>
                      <label>Role Name<span class="text-red-500">*</span></label>
                      <h3 class="m-0 font-medium">{{ profileData.firstName }}</h3>
                    </ng-template>
                  </p-card>
                </ng-template>
              </div>

              <!-- Application Name -->
              <div class="md:col-span-6 flex flex-col gap-1">
                <ng-container *ngIf="operation !== 'view'; else viewApplication">
                  <ng-container *ngIf="loading(); else applicationTemplate">
                    <app-skeleton id="label-input-items"></app-skeleton>
                  </ng-container>
                  <ng-template #applicationTemplate>
                    <label class="label-text font">Application Name<span class="text-red-500">*</span></label>
                    <p-select [options]="applicationList" [filter]="true" appendTo="body" class="w-full"
                      [(ngModel)]="profileData.selectedApplication" (onBlur)="validateApplicationSelection()"
                      (onChange)="isApplicationExists = false; isApplicationNameSelected = true"
                      optionLabel="applicationName" placeholder="Select application" optionValue="applicationId"
                      [ngModelOptions]="{ standalone: true }" filterBy="applicationName" required />
                    <div *ngIf="isApplicationTouched && !isApplicationNameSelected">
                      <small class="text-red-500">* Application Name is required</small>
                    </div>
                  </ng-template>
                </ng-container>

                <ng-template #viewApplication>
                  <p-card class="card-border">
                    <ng-container *ngIf="loading(); else showApplication">
                      <app-skeleton id="label-input-items"></app-skeleton>
                    </ng-container>
                    <ng-template #showApplication>
                      <label>Application Name<span class="text-red-500">*</span></label>
                      <h3 *ngIf="profileData.selectedApplication" class="m-0 font-medium">
                        {{ getSelectedApplicationName() }}
                      </h3>
                    </ng-template>
                  </p-card>
                </ng-template>

                <div *ngIf="isApplicationExists">
                  <small class="text-red-500">Application was deleted, please assign a new one or contact admin.</small>
                </div>
              </div>

              <!-- Role Description -->
              <div class="md:col-span-12 flex flex-col gap-1">
                <ng-container *ngIf="operation !== 'view'; else viewDescription">
                  <ng-container *ngIf="loading(); else descriptionTemplate">
                    <app-skeleton id="label-input-items"></app-skeleton>
                  </ng-container>
                  <ng-template #descriptionTemplate>
                    <label class="label-text">Role Description</label>
                    <textarea pInputTextarea autoResize="true" [(ngModel)]="profileData.description"
                      class="form-control w-full  hover-text-color custom-focus-border"
                      placeholder="Write role description..." name="description" (keydown)="space($event)"
                      (keypress)="onlyAlphabet($event,255,false)" rows="4" style="height: 140px; color: #334155;">
                    </textarea>
                  </ng-template>
                </ng-container>

                <ng-template #viewDescription>
                  <p-card class="card-border">
                    <ng-container *ngIf="loading(); else showDescription">
                      <app-skeleton id="label-input-items"></app-skeleton>
                    </ng-container>
                    <ng-template #showDescription>
                      <label class="label-text">Role Description</label>
                      <h3 class="m-0 font-medium">
                        {{ profileData.description || '-' }}
                      </h3>
                    </ng-template>
                  </p-card>
                </ng-template>
              </div>
            </div>

            <!-- Footer Buttons -->
            <div class="flex gap-3 mt-4 justify-end">
              <ng-container *ngIf="loading(); else buttonsTemplate">
                <ng-container *ngIf="operation === 'view'; else editButtons">
                  <app-skeleton id="form-fields" [size]="{ width: '5rem', height: '2rem' }"></app-skeleton>
                </ng-container>
                <ng-template #editButtons>
                  <ng-container *ngFor="let i of [1,2]">
                    <app-skeleton id="form-fields" [size]="{ width: '5rem', height: '2rem' }"></app-skeleton>
                  </ng-container>
                </ng-template>
              </ng-container>

              <ng-template #buttonsTemplate>
                <p-button severity="secondary" label="Cancel" (onClick)="navigateToProfilesList()" />
                <p-button type="submit" *ngIf="operation !== 'view' && operation !== 'edit'"
                  [disabled]="isFormNotValid() || !profileData['selectedApplication'] || isRoleNameNotValid || loading() || isAddUpdateButtonClicked"
                  (onClick)="onFormSubmit(f)" label="Continue" />

                <p-button type="submit" *ngIf="operation !== 'view' && operation === 'edit'"
                  [disabled]="isFormNotValid() || isRoleNameNotValid || f.invalid || isApplicationExists || loading() || isAddUpdateButtonClicked"
                  (onClick)="update()" label="Update" />
              </ng-template>
            </div>
          </form>
        </ng-template>
      </p-step-panel>

      <p-step-panel [value]="1" ngSkipHydration>
        <!--Header-->
        <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
          <span (click)="onToggleTab('resources', onClick)" (keydown)="onToggleTab('resources', onClick)">
            <i class="ti ti-user"></i> Assign Resources
          </span>
        </ng-template>
        <!--Content-->
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback"
          let-index="index">
          <p-card>
            <ng-template pTemplate="header">
              <div class="flex p-3">
                @if (loading()) {
                <app-skeleton [id]="'form-fields'" [size]="{ width: '8rem' }"></app-skeleton>
                } @else {
                {{ profileData.applicationName }}
                }
              </div>
            </ng-template>

            @if (loading()) {
            <div class="grid grid-cols-12 resource-grid">
              @for (i of [1, 2, 3, 4]; track i) {
              <div class="col-span-3">
                <div class="gridcol-header">
                  <app-skeleton [id]="'form-fields'" [size]="{ width: '6rem', height: '2rem' }"></app-skeleton>
                  <span class="mt-2">
                    <app-skeleton [id]="'form-fields'" [size]="{ width: '9rem', height: '1.5rem' }"></app-skeleton>
                  </span>
                </div>
                <div class="body-row mt-2">
                  <p-skeleton height="20rem"></p-skeleton>
                </div>
              </div>
              }
            </div>
            } @else {
            <div class="grid grid-cols-12 border-1 border-gray-200 rounded-md">

              <!-- Dashboards -->
              <div class="col-span-3 p-0 border-r-1 border-gray-200">
                <div class="flex px-3 py-2 bg-gray-100 items-center gap-3 text-sm">
                  <label for="searchApi">Dashboard</label>
                  <p-iconfield class="w-full">
                    <p-inputicon> <i-tabler name="search" class="w-5! h-5! !stroke-[1.5px]"></i-tabler></p-inputicon>
                    <input type="text" class="w-full" pSize="small" pInputText placeholder="Search for Dashboard"
                      [(ngModel)]="searchDashboard" />
                  </p-iconfield>
                </div>
                <div class="p-3">
                  <ng-container
                    *ngIf="(resourceList?.['Dashboards'] | searchFilter:searchDashboard:'resourceName') as filteredDashboards">
                    <div *ngIf="filteredDashboards.length > 0; else noDashboardsDataTemplate">
                      <div class="flex my-3 gap-3" *ngIf="operation !== 'view'">
                        <p-button label="Select All" size="small" [outlined]="true" severity="secondary"
                          (onClick)="selectAll('Dashboards', searchDashboard)" />
                        <p-button label="Clear All" size="small" [outlined]="true" severity="secondary"
                          (onClick)="clearAll('Dashboards', searchDashboard)" />
                      </div>
                      <div class="flex flex-wrap gap-2 max-h-20rem overflow-y-auto ng-star-inserted">
                        <ng-container *ngFor="let item of filteredDashboards">
                          <ng-container *ngFor="let action of item['actionsInfo']; let j = index">
                            <p-button [disabled]="operation === 'view'" [title]="item.resourceName"
                              (onClick)="resourceToggle('Dashboards', item['resourceName'], j)"
                              [outlined]="action.isAssigned ? 'false' : 'true'" size="small">
                              <!-- <span>{{ item?.resourceName | titlecase }} ({{ actionNameMapping[action?.actionName]
                                }})</span> -->
                              <span>
                                {{ item?.resourceName | titlecase }}
                                {{ actionNameMapping[action?.actionName]}}
                              </span>
                            </p-button>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #noDashboardsDataTemplate>
                    <div class="flex justify-center align-items-center py-4">No Dashboards to display</div>
                  </ng-template>
                </div>
              </div>

              <!-- Widgets -->
              <div class="col-span-3 p-0 border-r-1 border-gray-200">
                <div class="flex px-3 py-2 bg-gray-100 items-center gap-3 text-sm">
                  <label for="searchApi">Widget</label>
                  <p-iconfield class="w-full">
                    <p-inputicon> <i-tabler name="search" class="w-5! h-5! !stroke-[1.5px]"></i-tabler></p-inputicon>
                    <input type="text" class="w-full" pSize="small" pInputText placeholder="Search for Widget"
                      [(ngModel)]="searchWidget" />
                  </p-iconfield>
                </div>
                <div class="p-3">
                  <ng-container
                    *ngIf="(resourceList?.['Widgets'] | searchFilter:searchWidget:'resourceName') as filteredWidgets">
                    <div *ngIf="filteredWidgets.length > 0; else noWidgetsDataTemplate">
                      <div class="flex my-3 gap-3" *ngIf="operation !== 'view'">
                        <p-button label="Select All" size="small" [outlined]="true" severity="secondary"
                          (onClick)="selectAll('Widgets', searchWidget)" />
                        <p-button label="Clear All" size="small" [outlined]="true" severity="secondary"
                          (onClick)="clearAll('Widgets', searchWidget)" />
                      </div>
                      <div class="flex flex-wrap gap-2 max-h-20rem overflow-y-auto ng-star-inserted">
                        <ng-container *ngFor="let item of filteredWidgets">
                          <ng-container *ngFor="let action of item['actionsInfo']; let j = index">
                            <p-button [disabled]="operation === 'view'" [title]="item.resourceName"
                              (onClick)="resourceToggle('Widgets', item['resourceName'], j)"
                              [outlined]="action.isAssigned ? 'false' : 'true'">
                              <!-- <span *ngIf="profileData.applicationName == 'User Management'">{{ item?.resourceName | titlecase }} ({{ actionNameMapping[action?.actionName]
                                }})</span>
                              <span *ngIf="profileData.applicationName != 'User Management'">{{ item?.resourceName | titlecase }} </span> -->
                              <span>
                                {{ item?.resourceName | titlecase }}
                                {{ actionNameMapping[action?.actionName]}}
                              </span>

                            </p-button>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #noWidgetsDataTemplate>
                    <div class="flex justify-center align-items-center py-4">No Widgets to display</div>
                  </ng-template>
                </div>
              </div>

              <!-- APIs -->
              <div class="col-span-3 p-0 border-r-1 border-gray-200">
                <div class="flex px-3 py-2 bg-gray-100 items-center gap-3 text-sm">
                  <label for="searchApi">API's</label>
                  <p-iconfield class="w-full">
                    <p-inputicon> <i-tabler name="search" class="w-5! h-5! !stroke-[1.5px]"></i-tabler></p-inputicon>
                    <input type="text" class="w-full" pSize="small" pInputText placeholder="Search for API"
                      [(ngModel)]="searchApi" />
                  </p-iconfield>
                </div>
                <div class="p-3">
                  <ng-container
                    *ngIf="(resourceList?.['APIs'] | searchFilter:searchApi:'resourceName') as filteredAPIs">
                    <div *ngIf="filteredAPIs.length > 0; else noAPIsDataTemplate">
                      <div class="flex my-3 gap-3" *ngIf="operation !== 'view'">
                        <p-button label="Select All" size="small" [outlined]="true" severity="secondary"
                          (onClick)="selectAll('APIs', searchApi)" />
                        <p-button label="Clear All" size="small" [outlined]="true" severity="secondary"
                          (onClick)="clearAll('APIs', searchApi)" />
                      </div>
                      <div class="flex flex-wrap gap-2 max-h-20rem overflow-y-auto ng-star-inserted">
                        <ng-container *ngFor="let item of filteredAPIs">
                          <ng-container *ngFor="let action of item['actionsInfo']; let j = index">
                            <p-button [disabled]="operation === 'view'" [title]="item.resourceName"
                              (onClick)="resourceToggle('APIs', item['resourceName'], j)"
                              [outlined]="action.isAssigned ? 'false' : 'true'">
                              <!-- <span>{{ item?.resourceName | titlecase }} ({{ actionNameMapping[action?.actionName]
                                }})</span> -->
                              <span>
                                {{ item?.resourceName | titlecase }}
                                {{ actionNameMapping[action?.actionName]}}
                              </span>
                            </p-button>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #noAPIsDataTemplate>
                    <div class="flex justify-center align-items-center py-4">No APIs to display</div>
                  </ng-template>
                </div>
              </div>

              <!-- Others (Fixed Block) -->
              <div class="col-span-3 p-0">
                <!-- <div class="flex px-3 py-2 surface-100 align-items-center gap-3">
                  <label for="searchUrl">Others</label>
                  <p-inputGroup>
                    <p-inputGroupAddon><i class="ti ti-search"></i></p-inputGroupAddon>
                    <input pInputText type="text" placeholder="Search for Other" id="searchUrl" [(ngModel)]="searchUrl" />
                  </p-inputGroup>
                </div> -->
                <div class="flex px-3 py-2 bg-gray-100 items-center gap-3 text-sm">
                  <label for="searchApi">Others</label>
                  <p-iconfield class="w-full">
                    <p-inputicon> <i-tabler name="search" class="w-5! h-5! !stroke-[1.5px]"></i-tabler></p-inputicon>
                    <input type="text" class="w-full" pInputText pSize="small" placeholder="Search for Others"
                      [(ngModel)]="searchUrl" />
                  </p-iconfield>
                </div>
                <div class="p-3">
                  <ng-container
                    *ngIf="(resourceList?.['Others'] | searchFilter:searchUrl:'resourceName') as filteredOthers">
                    <div *ngIf="filteredOthers.length > 0; else noOthersDataTemplate">
                      <div class="flex my-3 gap-3" *ngIf="operation !== 'view'">
                        <p-button label="Select All" size="small" [outlined]="true" severity="secondary"
                          (onClick)="selectAll('Others', searchUrl)" />
                        <p-button label="Clear All" size="small" [outlined]="true" severity="secondary"
                          (onClick)="clearAll('Others', searchUrl)" />
                      </div>
                      <div class="flex flex-wrap gap-2 max-h-20rem overflow-y-auto ng-star-inserted">
                        <ng-container *ngFor="let item of filteredOthers">
                          <ng-container *ngFor="let action of item['actionsInfo']; let j = index">
                            <p-button [disabled]="operation === 'view'" [title]="item.resourceName"
                              (onClick)="resourceToggle('Others', item['resourceName'], j)"
                              [severity]="action.isAssigned ? 'primary' : 'secondary'">
                              <span>{{ item.resourceName | titlecase }} ({{ actionNameMapping[action.actionName]
                                }})</span>
                            </p-button>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #noOthersDataTemplate>
                    <div class="flex justify-center align-items-center py-4">No Others to display</div>
                  </ng-template>
                </div>
              </div>
            </div>
            }
          </p-card>

          <div class="flex justify-end gap-2 mt-3">
            @if (loading()) {
            @if (operation == 'view') {
            <app-skeleton id="form-fields" [size]="{ width: '5rem', height: '2rem' }"></app-skeleton>
            } @else {
            @for (i of [1, 2]; track i) {
            <app-skeleton id="form-fields" [size]="{ width: '5rem', height: '2rem' }"></app-skeleton>
            }
            }
            } @else {
            <p-button type="button" severity="secondary" (onClick)="navigateToProfilesList()" label="Cancel" />
            <p-button type="submit" *ngIf="operation !== 'view'" (onClick)="update()" [disabled]="loading()"
              [label]="operation == 'edit' ? 'Update' : 'Continue'" />

            }
          </div>
        </ng-template>
      </p-step-panel>

      <!-- <p-step-panel [value]="2">
      <ng-template pTemplate="header" let-onClick="onClick" let-index="index">
        <span
          [ngClass]="{ 'text-gray-400 cursor-not-allowed': disableStep }"
          (click)="!disableStep && onToggleTab('scope', onClick)"
          (keydown)="!disableStep && onToggleTab('scope', onClick)">
          <i class="ti ti-user"></i> Assign Scope
        </span>
      </ng-template>

      <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index">
        <div class="step-disabled-overlay" *ngIf="disableStep"></div>

        <app-role-valid-scope
          *ngIf="profileData.selectedApplication && scupdateopeEndPoint"
          [disabled]="operation === 'view' || disableStep"
          [application]="profileData.selectedApplication"
          [scopeEndPoint]="scopeEndPoint"
          [initScope]="initScope"
          (onScopeUpdate)="updateScope($event)"
          (roleLoading)="getLoader($event)">
        </app-role-valid-scope>

        <div class="flex justify-end gap-3 mt-4">
          @if (roleLoading()) {
            @if (operation === 'view') {
              <app-skeleton id="form-fields" [size]="{ width: '5rem', height: '2rem' }"></app-skeleton>
            } @else {
              @for (i of [1, 2]; track i) {
                <app-skeleton id="form-fields" [size]="{ width: '5rem', height: '2rem' }"></app-skeleton>
              }
            }
          } @else if (profileData.selectedApplication && scopeEndPoint) {
            <p-button
              type="button"
              label="Cancel"
              severity="secondary"
              [disabled]="disableStep"
              (onClick)="navigateToProfilesList()">
            </p-button>

            <p-button
              type="submit"
              *ngIf="operation !== 'view'"
              (onClick)="update()"
              [disabled]="disableStep || !validScope || roleLoading()"
              [label]="operation === 'edit' ? 'Update' : 'Save'">
            </p-button>
          }
        </div>
      </ng-template>
    </p-step-panel> -->



    </p-step-panels>
  </p-stepper>
</div>

<p-toast />